import React from "react";
import "../../../assets/styles/common/footer.css";
import { BsGithub, BsTwitter } from "react-icons/bs";
import {  FaFacebookF, FaLinkedinIn } from "react-icons/fa";

import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <>
    <div className="footer_main mt-5">
      <footer className="footer-container p-3">
        <Container fluid>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
              <div className="logo-img">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="121"
                  height="39"
                  viewBox="0 0 121 39"
                  fill="none"
                >
                  <path
                    d="M33.1854 11.3494L33.0466 11.1352H33.1073C32.309 9.04532 31.0854 7.13526 29.5061 5.53356C27.9528 3.98325 26.0958 2.76698 24.0478 1.96185C21.835 1.10532 19.4834 0.677056 17.1057 0.702752C14.7453 0.677056 12.411 1.10532 10.2156 1.96185C8.185 2.76698 6.34532 3.98325 4.81805 5.53356C3.26474 7.1267 2.06722 9.01962 1.27755 11.0924C0.401104 13.405 -0.0327811 15.8547 0.0019297 18.3215C-0.0327811 20.8226 0.401104 23.3065 1.27755 25.6534C2.05854 27.7433 3.26474 29.6619 4.81805 31.2807C6.34532 32.8396 8.185 34.073 10.2243 34.8782C10.5453 35.0066 10.8664 35.1265 11.1962 35.2208V29.5249C11.1962 29.1651 11.2222 28.8139 11.2829 28.4628C10.5714 28.0174 9.91186 27.4692 9.34781 26.8525C8.37591 25.7818 7.6383 24.5313 7.16103 23.1694C6.62301 21.6363 6.354 20.026 6.37136 18.3986C6.354 16.7797 6.62301 15.1695 7.16103 13.6449C7.6383 12.3001 8.38458 11.0582 9.34781 9.9875C10.285 8.96823 11.4391 8.16309 12.7148 7.61492C14.0858 7.04105 15.561 6.74983 17.0536 6.75839C18.5896 6.74126 20.1082 7.03248 21.5226 7.61492C22.8416 8.15453 24.0218 8.95966 24.9937 9.9875C25.9656 11.041 26.7119 12.2916 27.1805 13.6449C27.7098 15.178 27.9701 16.7797 27.9441 18.3986C27.9615 20.0174 27.7098 21.6363 27.1805 23.1694C26.7206 24.5313 25.9743 25.7904 24.9937 26.8525C24.4123 27.4692 23.7528 28.0088 23.0325 28.4542C23.102 28.8054 23.1367 29.1651 23.1367 29.5249V35.2036C23.4404 35.1008 23.7441 34.9981 24.0044 34.8782C26.0784 34.073 27.9528 32.8482 29.5061 31.2807C31.0681 29.6619 32.283 27.7519 33.0639 25.6534C33.9491 23.3065 34.383 20.8226 34.3482 18.3215C34.3916 15.9489 33.9925 13.5849 33.1854 11.3494Z"
                    fill="url(#paint0_linear_183_2332)"
                  />
                  <path
                    d="M120.187 15.5805V30.0215H113.895V17.4477C113.991 15.9402 113.505 14.4499 112.533 13.2765C111.544 12.2743 110.173 11.7518 108.758 11.8375C107.205 11.7604 105.704 12.3942 104.68 13.5505C103.63 14.9295 103.109 16.6255 103.213 18.3471V30.0215H75.0281V26.5954L87.6975 12.2743L87.6108 12.0602C85.8752 12.2315 83.3847 12.3171 80.1306 12.3171H75.731L75.3231 12.4799L68.5545 30.5954C67.9384 32.3427 67.0186 33.9616 65.8297 35.392C64.8665 36.4969 63.6082 37.3191 62.2025 37.7731C60.5103 38.2613 58.7574 38.4926 56.9958 38.4412C56.4665 38.4412 55.5206 38.4412 54.1756 38.3641V33.5419C54.9045 33.6104 55.6421 33.6361 56.3797 33.6275C57.4037 33.696 58.4277 33.4905 59.3475 33.0279C60.1198 32.4541 60.7186 31.6918 61.083 30.8095L61.4301 29.953L54.1756 10.2529L48.1012 18.5098L56.5533 30.0044H49.3508L47.945 28.1115C46.4438 25.8845 45.3417 24.1543 44.6041 22.9723H44.3438C43.5454 24.24 42.3913 25.953 40.8727 28.1115L39.5103 30.013H32.5508L40.9508 18.5612L32.976 7.64051H40.1438L41.133 8.97669C42.6777 11.2893 43.7971 13.0024 44.4653 14.1158H44.6909C45.9839 12.0602 47.112 10.33 48.0752 8.90817L48.995 7.64051H59.8768L61.4215 12.5398L62.2111 15.1094C63.2872 18.4327 64.2417 21.6019 65.0835 24.6083H65.3004C66.0987 21.8845 67.2355 18.2015 68.7021 13.5505L69.0926 12.3857L70.5938 7.64051H95.5595V11.4949L83.6537 25.3449L83.7318 25.6019C86.0227 25.4306 88.3484 25.3449 90.7261 25.3449H96.9219V7.64051H102.996L103.213 14.4413H103.482C103.708 12.3343 104.723 10.39 106.32 8.97669C107.812 7.64051 109.765 6.91246 111.787 6.93816C113.253 6.92103 114.694 7.2722 115.987 7.95742C117.271 8.64265 118.33 9.67048 119.041 10.9296C119.84 12.3514 120.23 13.9531 120.187 15.5805Z"
                    fill="#232728"
                  />
                  <defs>
                    <linearGradient
                      id="paint0_linear_183_2332"
                      x1="-0.0836126"
                      y1="17.9614"
                      x2="34.3516"
                      y2="17.9614"
                      gradientUnits="userSpaceOnUse"
                    >
                      <stop stopColor="#42C5F0" />
                      <stop offset="1" stopColor="#4779BC" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>
              <p className="footer-logo-p text-secondary">
                The wellbeing experience your employees want
              </p>

              {/* <button type="button" className="hero-button-demo">
                Request a demo
              </button> */}
              <Link to="https://calendly.com/oxyzn/meeting-with-oxyzn" target="_blank" className="hero-button-demo footer_btn" style={{display:"inline-block"}}>
                Request a demo
              </Link>
            </div>

            <div className="col-md-6">
              <div className="row">
                <div className="col-lg-4 col-md-4 col-sm-4 mb-4">
                  <h5 className="mb-3 footer-title">Oxyzn </h5>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-3">
                      <a href="#!" className="footer-link">
                        For Businesses
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="#!" className="footer-link">
                        Pricing plans
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="#!" className="footer-link">
                        Resources
                      </a>
                    </li>
                    <li className="mb-3">
                      <a href="#!" className="footer-link">
                        About
                      </a>
                    </li>
                    <li className="mb-3">
                      <Link to="/pricing" className="footer-link">
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 mb-4">
                  <div>
                    <h5 className="mb-3 footer-title">Legal </h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          Terms & Conditions
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          Cookie policy
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          Privacy policy
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          GDPR Disclosure
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="col-lg-4 col-md-4 col-sm-4 mb-4">
                  <div>
                    <h5 className="mb-3 footer-title">Get in touch</h5>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          alexandra@oxyzn.net
                        </a>
                      </li>
                      <li className="mb-3">
                        <a href="#!" className="footer-link">
                          +447541730850
                        </a>
                      </li>
                      <li>
                        <a href="#!" className="footer-link">
                          76 Dean St, London W1D 3SQ, United Kingdom
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-3 col-sm-12 mb-4">
              <div className="social_meadia_icon_wrap">
                <div className="social_meadia_icon">
                  <div>
                    <a href="#" target={"_blank"}>
                      <BsTwitter />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.linkedin.com/company/urban-yoga-lab/"
                      target={"_blank"}
                    >
                      <FaLinkedinIn />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.facebook.com/UrbanYogaLab"
                      target={"_blank"}
                    >
                      <FaFacebookF />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.instagram.com/urbanyogalab/"
                      target={"_blank"}
                    >
                      <BsGithub />
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.youtube.com/channel/UCStqUzcxtM3iwAxxcCFzBmw"
                      target={"_blank"}
                    >
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Social icon" clipPath="url(#clip0_183_2374)">
                          <path
                            id="Vector"
                            d="M17.7695 10.7985C18.318 9.27041 19.8977 4.8501 19.8977 3.43447C19.8977 2.1876 19.1617 1.14229 17.8492 1.14229C15.7586 1.14229 13.8836 7.31572 13.2977 8.7876C12.843 7.45166 10.7148 0.70166 8.83985 0.70166C7.38204 0.70166 6.69766 1.7751 6.69766 3.1251C6.69766 4.77979 8.30079 9.06885 8.88204 10.7188C8.58672 10.611 8.26797 10.5173 7.94454 10.5173C6.84766 10.5173 5.68047 11.8813 5.68047 12.9829C5.68047 13.4001 5.91016 13.986 6.05547 14.3751C4.32579 14.8438 3.66016 15.997 3.66016 17.736C3.65547 21.1204 6.86172 24.7017 11.3711 24.7017C16.9024 24.7017 20.343 20.5485 20.343 15.1907C20.343 13.1704 20.0195 11.347 17.7695 10.7985ZM16.1102 5.76416C16.2977 5.1876 17.0992 2.7501 17.8492 2.7501C18.2523 2.7501 18.3602 3.16729 18.3602 3.5001C18.3602 4.39541 16.5508 9.34072 16.1524 10.4376L14.5586 10.1563L16.1102 5.76416ZM8.16954 2.96572C8.16954 2.40791 8.84923 0.823535 10.3398 5.17354L11.9617 9.8751C11.2305 9.81416 10.6633 9.73447 10.3024 9.94072C9.79141 8.59072 8.16954 4.32979 8.16954 2.96572ZM8.06172 12.1392C9.43516 12.1392 11.207 16.5735 11.207 17.1735C11.207 17.4126 10.9773 17.7079 10.7102 17.7079C9.73047 17.7079 7.10547 14.1032 7.10547 13.1282C7.11016 12.7673 7.70079 12.1392 8.06172 12.1392ZM16.7008 20.872C15.3367 22.372 13.593 23.1501 11.5586 23.1501C8.77422 23.1501 6.57579 21.622 5.51641 19.011C4.71485 16.9767 5.69454 15.8095 6.48204 15.8095C7.01641 15.8095 9.02735 18.636 9.02735 19.236C9.02735 19.4657 8.66641 19.6251 8.47891 19.6251C7.72422 19.6251 7.42891 18.8985 6.0836 17.2157C4.69141 18.6079 7.04454 21.2892 8.81641 21.2892C10.0398 21.2892 10.8367 20.1548 10.5977 19.3204C10.7711 19.3204 10.9867 19.3345 11.1461 19.2923C11.1977 20.5626 11.5727 22.0767 13.1008 22.1845C13.1008 22.1423 13.1945 21.8517 13.1945 21.8376C13.1945 21.022 12.6977 20.3095 12.6977 19.4798C12.6977 18.1532 13.7149 16.8688 14.7461 16.1188C15.1211 15.8376 15.5758 15.6642 16.0164 15.5048C16.4711 15.3313 16.9539 15.1298 17.3008 14.7829C17.2492 14.2579 17.0336 13.7938 16.5086 13.7938C15.2102 13.7938 10.8555 13.9813 10.8555 11.9329C10.8555 11.6188 10.8602 11.3188 11.6711 11.3188C13.1852 11.3188 17.0289 11.6938 18.1539 12.6829C19.0023 13.4376 19.293 17.9892 16.7008 20.872ZM12.0789 14.9657C12.5336 15.111 13.0023 15.1532 13.4711 15.247C13.1242 15.5001 12.8148 15.8095 12.5195 16.1423C12.3883 15.7438 12.2289 15.3548 12.0789 14.9657Z"
                            fill="#232728"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_183_2374">
                            <rect
                              width="24"
                              height="24"
                              fill="white"
                              transform="translate(0 0.70166)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </div>
                  <div>
                    <a
                      href="https://www.youtube.com/channel/UCStqUzcxtM3iwAxxcCFzBmw"
                      target={"_blank"}
                    >
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g id="Social icon">
                          <path
                            id="Vector"
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M12 0.70166C5.37527 0.70166 0 6.07693 0 12.7017C0 19.3264 5.37527 24.7017 12 24.7017C18.6117 24.7017 24 19.3264 24 12.7017C24 6.07693 18.6117 0.70166 12 0.70166ZM19.9262 6.23311C21.3579 7.97715 22.217 10.2027 22.243 12.6105C21.9046 12.5455 18.5206 11.8557 15.1106 12.2852C15.0325 12.116 14.9675 11.9337 14.8894 11.7516C14.6811 11.257 14.4469 10.7494 14.2126 10.2678C17.9869 8.73206 19.705 6.51945 19.9262 6.23311ZM12 2.47173C14.603 2.47173 16.9848 3.44787 18.7939 5.04874C18.6117 5.30904 17.0629 7.37845 13.4186 8.74504C11.7397 5.66044 9.87855 3.1355 9.5922 2.74504C10.3601 2.56283 11.1671 2.47173 12 2.47173ZM7.63995 3.43485C7.91325 3.79927 9.73538 6.33724 11.4404 9.35674C6.65076 10.6323 2.42083 10.6062 1.96529 10.6062C2.62907 7.43051 4.77657 4.78842 7.63995 3.43485ZM1.74404 12.7147C1.74404 12.6105 1.74404 12.5064 1.74404 12.4023C2.18655 12.4153 7.15835 12.4804 12.2733 10.9446C12.5727 11.5173 12.846 12.1029 13.1063 12.6886C12.9761 12.7277 12.8329 12.7668 12.7028 12.8058C7.41865 14.5107 4.60738 19.1702 4.3731 19.5606C2.7462 17.7516 1.74404 15.3438 1.74404 12.7147ZM12 22.9576C9.6312 22.9576 7.44469 22.1507 5.71367 20.7971C5.89588 20.4197 7.97827 16.411 13.757 14.3937C13.783 14.3806 13.7961 14.3806 13.8221 14.3676C15.2668 18.1029 15.8525 21.2396 16.0087 22.1376C14.7722 22.6713 13.4186 22.9576 12 22.9576ZM17.7136 21.2006C17.6096 20.5758 17.0629 17.5824 15.7223 13.899C18.9371 13.3914 21.7484 14.2245 22.0998 14.3416C21.6573 17.1919 20.0173 19.6518 17.7136 21.2006Z"
                            fill="#232728"
                          />
                        </g>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>

        
      </footer>
      
    </div>
    <div className="container-fluid  footer-bottom row">
          <div className="col-md-6">
            <div className="footer-bottom-copyrit ">
              <p>© 2023 Copyright:
              <a className="text-dark " href="https://oxyzn.com/">
                Oxyzn
              </a>
              
              <span className="ms-4">reg. 22398745</span>
              </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="boot-m-footer d-flex justify-content-evenly">
              <p className=" text-secondary ">Terms & Conditions</p>
              <p className=" text-secondary">Cookie policy</p>
              <p className=" text-secondary">Privacy policy</p>
              <p className=" text-secondary">GDPR Disclosure</p>
            </div>
          </div>
        </div></>
  );
};

export default Footer;
